import { Component, Input, Renderer2, ElementRef, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { FormArray, FormGroup, Validators, ValidatorFn, FormsModule, FormBuilder, ReactiveFormsModule, AbstractControl } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

import { BackendV4Service, SiteTemplateV4, DropDownMenu } from '../../../service/backend-v4.service';

@Component({
  selector: 'app-template-c',
  standalone: true,
  imports: [MatButtonModule, MatProgressSpinnerModule, MatCardModule, MatSelectModule, MatInputModule, MatIconModule, ReactiveFormsModule, FormsModule, MatFormFieldModule],
  templateUrl: './template-c.component.html',
  styleUrl: './template-c.component.scss'
})

export class TemplateCComponent {

  @Input()
  set templateData(value: any) {
    this._templateData = value
    this.redraw()
  }

  @Input() canEdit: boolean = false
  isEditable = false

  private formBuilder = inject(FormBuilder);
  backEndV4Service = inject(BackendV4Service)

  public _templateData: any = null;

  safeHtmlBody: any;
  iframe: any;
  sectionList = new Array()

  informationRequestFormGroup = this.formBuilder.group({
    name: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    questions: ['', Validators.required],
  });


  constructor(public sanitizer: DomSanitizer, private router: Router, private renderer: Renderer2, private el: ElementRef) {



  }

  redraw() {
    this.sectionList = new Array()

    if (this._templateData.context && this._templateData.context.context && this._templateData.context.context.questions) {
      let index = 0
      for (const question of this._templateData.context.context.questions) {
        const answer: string = this._templateData.context.context.answers[index]
        this.sectionList.push({ question, answer })
        index++
      }
    }

    this.safeHtmlBody = this.sanitizer.bypassSecurityTrustHtml(this._templateData.body)
    if (this._templateData.context && this._templateData.context.context && this._templateData.context.context.iframe) {
      this.iframe = this.sanitizer.bypassSecurityTrustHtml(this._templateData.context.context.iframe)
    }

    if (this._templateData.backgroundImage && this._templateData.backgroundImage.length > 1) {
      this.renderer.setStyle(this.el.nativeElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('div'), 'background-image', `url(${this._templateData.backgroundImage})`);
    } else {
      this.renderer.setStyle(this.el.nativeElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('div'), 'background-image', `url(${''})`);
    }

  }

  onSubmit() {
    if (this.informationRequestFormGroup.valid) {
      console.log(this.informationRequestFormGroup.value)
      this.backEndV4Service.postQuestion(this.informationRequestFormGroup.value)
    }
  }
}

